import {
  Injectable,
  Signal,
  WritableSignal,
  computed,
  signal,
} from '@angular/core';
import { IUser, IUpdateUser} from '@interface/user.interface';
import { UsersApiService } from '../http/services/user.service'; 
import { Observable } from 'rxjs';
import { MutationResult } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class UserService<T extends IUser> {
  private userState: WritableSignal<T> = signal({} as T);

  constructor(private usersApiService: UsersApiService) {}

  public set<K extends keyof T>(key: K, data: T[K]) {
    this.userState.update((current) => ({ ...current, [key]: data }));
  }

  public setState(partial: Partial<T>): void {
    this.userState.update((current) => ({ ...current, ...partial }));
  }

  public select<K extends keyof T>(key: K): Signal<T[K]> {
    return computed(() => this.userState()[key]);
  }

  public updateUser(email: string, userData: IUpdateUser): Observable<MutationResult<IUser>> {
    return this.usersApiService.updateUser(email, userData);
  }
}
